<template>
  <iColumn
    :width="getOptionValue(LayoutWidth) || 'hug'"
    height="hug"
    gap="extraSmall"
    align="left"
    :style-overrides="appInputWrapperStyleOverrides"
  >
    <iText v-if="labelValue" variant="subtle" font-size="small">
      {{ labelValue }}
    </iText>
    <iRow vertical-align="middle" gap="small" wrap="nowrap">
      <iUploader
        :acceptable-file-types="acceptableFileTypes"
        @upload-file="uploadFile"
      >
        <iButton
          variant="secondary"
          size="small"
          :is-loading="isUploading"
          :disabled="isUploading"
        >
          {{ buttonLabel }}
        </iButton>
      </iUploader>
    </iRow>
    <iText v-if="uploadError" variant="error" font-size="small">
      {{ uploadError }}
    </iText>
  </iColumn>
</template>

<script>
import { plainLabelText } from "%/dynamic-component-editor/helpers/plain-label-text.mjs";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import DynamicAppInputOptionsMixin from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-options-mixin";
import FileUploadBehaviour from "%/dynamic-component-editor/standard-elements/file-upload/file-upload-behaviour-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import Label from "%/dynamic-component-editor/options/label";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import SeedField from "%/dynamic-component-editor/options/seed-field";
import MediaTypeField from "%/dynamic-component-editor/options/media-type-field";

import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

const CHOOSE_LABEL = "Choose a file";
const UPLOADING_LABEL = "Uploading...";

export default {
  name: "DynamicAppFileInputElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, DynamicAppInputOptionsMixin, FileUploadBehaviour],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  options: [
    Label,
    CommitAction,
    SeedField,
    MediaTypeField,
    BackgroundColor,
    BorderColor,
    BorderWidth,
  ],
  optionBundles: [
    new BasicTextOptions({}, {
      "font-family": true,
    }),
    new LayoutWidthHeightOptions({}, {
      "layout-height": true,
      "max-width": true,
      "max-height": true,
      "min-width": true,
      "min-height": true,
    }),
    new SpacingOptions(),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  computed: {
    LayoutWidth() {
      return LayoutWidth;
    },
    labelValue() {
      return plainLabelText(this.getOptionValue(Label));
    },
    buttonLabel() {
      return this.isUploading ? UPLOADING_LABEL : CHOOSE_LABEL;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
